import { AuditLogsManager } from "@/components/Settings/AuditLogsManager";

export function SettingsAuditLogs() {
  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-3xl font-bold">Audit Logs</h1>
        <p className="mt-2 text-muted-foreground">
          View and search through the audit log history of system operations.
        </p>
      </div>
      <AuditLogsManager />
    </div>
  );
}